import { render } from "./BrandListPage.vue?vue&type=template&id=50399cc4&scoped=true&ts=true"
import script from "./BrandListPage.vue?vue&type=script&lang=ts"
export * from "./BrandListPage.vue?vue&type=script&lang=ts"

import "./BrandListPage.vue?vue&type=style&index=0&id=50399cc4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50399cc4"]])

export default __exports__